import React from 'react';
import styled from '@emotion/native';
import { TouchableOpacity, Image, Linking, Platform } from 'react-native';
import AppleLogo from '@/assets/images/Apple.png';
import { darkGreen, primaryHover, sand, white } from '@/shared/styles/colors';
import { BaseText } from '@/shared/components/StyledText';
import { IS_WEB, EMME_APP_STORE_URL } from '@/shared/constants/utility';
import useIsDesktop from '@/shared/hooks/useIsDesktop';
import { useWebHoverToggle } from '@/shared/hooks/useWebHoverToggle';
import { IsDesktopProps } from '@/shared/styles/types';

interface StyledDownloadAppButtonProps extends IsDesktopProps {
  isHovered?: boolean;
}

const DownloadAppButton = () => {
  const isDesktop = useIsDesktop();
  const { isHovered, webHoverProps } = useWebHoverToggle();

  const handlePress = () => {
    if (IS_WEB) {
      Linking.openURL(EMME_APP_STORE_URL);
    } else {
      if (Platform.OS === 'ios') {
        Linking.openURL(EMME_APP_STORE_URL);
      } else if (Platform.OS === 'android') {
        // TODO: Add Play Store URL when available
        Linking.openURL(EMME_APP_STORE_URL);
      }
    }
  };

  return (
    <StyledButton
      onPress={handlePress}
      isDesktop={isDesktop}
      isHovered={isHovered}
      {...webHoverProps}
    >
      <Logo source={AppleLogo} tintColor={sand} />
      <TextContainer>
        <SmallText>Download on the</SmallText>
        <LargeText>App Store</LargeText>
      </TextContainer>
    </StyledButton>
  );
};

const StyledButton = styled(TouchableOpacity)<StyledDownloadAppButtonProps>(
  ({ isDesktop, isHovered }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 50,
    minWidth: isDesktop ? 200 : 330,
    height: 60,
    backgroundColor: IS_WEB && isHovered ? primaryHover : darkGreen,
    paddingHorizontal: 25,
    paddingVertical: 12,
    gap: 12,
  }),
);

const Logo = styled(Image)({
  width: 26,
  height: 31,
  resizeMode: 'contain',
});

const TextContainer = styled.View({
  flexDirection: 'column',
  alignItems: 'flex-start',
});

const SmallText = styled(BaseText)({
  color: white,
  fontSize: 11,
  lineHeight: 12,
  letterSpacing: 0.5,
});

const LargeText = styled(BaseText)({
  color: white,
  fontWeight: '600',
  fontSize: 22,
  lineHeight: 24,
  letterSpacing: -0.5,
});

export default DownloadAppButton;
